import { render, staticRenderFns } from "./Ios.vue?vue&type=template&id=ef0b2b2c&lang=pug"
import script from "./Ios.vue?vue&type=script&lang=js"
export * from "./Ios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports